import { useEffect, useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import styled, { css } from 'styled-components';
import { IconButton } from '@cbhq/cds-web/buttons/IconButton';
import { Box } from '@cbhq/cds-web/layout/Box';
import { ThemeProvider } from '@cbhq/cds-web/system/ThemeProvider';
import { spacing, palette } from '@cbhq/cds-web/tokens';
import { useTrackingManager } from '../TrackingManagerContext.js';
import PrivacyLink from './PrivacyLink.js';
import useMessages from './useMessages.js';
import { jsx, jsxs } from 'react/jsx-runtime';
const CookieLink = str => [/*#__PURE__*/jsx(PrivacyLink, {
  color: "foregroundMuted",
  children: str
}, "PrivacyLink")];
function BannerContentSlimExp({
  onDismiss,
  showPreferencesModal,
  hasDismissed
}) {
  const _useTrackingManager = useTrackingManager(),
    log = _useTrackingManager.log;
  useEffect(() => {
    if (!hasDismissed) {
      log('cookie_consent_footer_viewed');
    }
  }, []);
  const handleDismiss = useCallback(() => {
    log('cookie_consent_footer_dismissed');
    onDismiss?.();
  }, [onDismiss, log]);
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const messages = useMessages();
  if (hasDismissed) {
    return null;
  }
  return /*#__PURE__*/jsx(Wrapper, {
    children: /*#__PURE__*/jsx(ThemeProvider, {
      children: /*#__PURE__*/jsxs(Box, {
        alignItems: "center",
        justifyContent: "center",
        spacing: 2,
        elevation: 1,
        background: true,
        children: [/*#__PURE__*/jsx(DescriptionText, {
          children: formatMessage(messages.defaultBannerDescription, {
            link: CookieLink,
            button: node => [/*#__PURE__*/jsx(ManageSettingsButton, {
              onClick: showPreferencesModal,
              "aria-haspopup": true,
              children: node
            }, "ManageCookieSettingsExpBtn")]
          })
        }), /*#__PURE__*/jsxs(CTA, {
          children: [/*#__PURE__*/jsx(IconButton, {
            name: "gear",
            onPress: showPreferencesModal,
            variant: "primary",
            accessibilityLabel: formatMessage(messages.bannerSettingsCTA),
            transparent: true
          }), /*#__PURE__*/jsx(IconButton, {
            name: "close",
            onPress: handleDismiss,
            variant: "primary",
            accessibilityLabel: formatMessage(messages.bannerDismissCTA),
            transparent: true
          })]
        })]
      })
    })
  });
}
const Wrapper = styled.div`
  ${({
  theme
}) => css`
    position: sticky;
    bottom: 0;
    z-index: ${theme.zIndex.overlay};
  `}
`;
const CTA = styled.div`
  ${({
  theme
}) => css`
    display: flex;
    align-items: center;
    @media (max-width: ${theme.breakpoints.tablet}px) {
      position: absolute;
      right: ${spacing[2]};
      bottom: ${spacing[0.5]};
      transform: none;
    }
  `}
`;
const DescriptionText = styled.div`
  ${({
  theme
}) => css`
    font-size: ${theme.fontSize.sm};
    color: ${palette.foregroundMuted};
    line-height: ${spacing[3]};
    padding-left: ${spacing[3]};
    padding-right: ${spacing[10]};
    max-width: 1000px;
    @media (max-width: ${theme.breakpoints.tablet}px) {
      padding: 0;
      padding-bottom: ${spacing[3]};
    }
  `}
`;
const ManageSettingsButton = styled.button`
  background: transparent;
  border: none;
  white-space: nowrap;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  color: ${palette.foregroundMuted};
`;
const BannerContentSlimExp$1 = /*#__PURE__*/memo(BannerContentSlimExp);
export { BannerContentSlimExp$1 as default };
//# sourceMappingURL=CookieBannerContentSlimExp.js.map
